import AbstractSlider from '../../modules/slider';
import './style.less';

class SpecSlider extends AbstractSlider {
    get mobileBigOptions() {
        return {
            slidesToShow: 2,
            dots: false,
            arrow: true
        };
    }

    get tabletOptions() {
        return {
            slidesToShow: 3,
            dots: false,
            arrow: true
        };
    }
}

$(window).load(() => {
    const specElement = $('.js-slick-specials-list');
    if (specElement.length !== 0) {
        new SpecSlider(specElement);
    }
});



// WEBPACK FOOTER //
// ./blocks/sem-spec/index.js